export default (request) => ({
  getById: (fundId, options) => request({
    method: 'get',
    url: `/funds/${fundId}`,
    ...options,
  }),
  returnsById: (fundId, options) => request({
    method: 'get',
    url: `/funds/${fundId}/returns`,
    ...options,
  }),
  returnsRelativeById: (fundId, options) => request({
    method: 'get',
    url: `/funds/${fundId}/returns/relative`,
    ...options,
  }),
  monthly: (fundId, options) => request({
    method: 'get',
    url: `/funds/${fundId}/monthly`,
    ...options,
  }),
  search: (options) => request({
    method: 'post',
    url: '/funds/search',
    ...options,
  }),
  list: (options) => request({
    method: 'get',
    url: '/funds/',
    ...options,
  }),
});

//     search: (options?: AxiosRequestConfig) => axios.post('/funds/search', options),
